import { useCallback, useEffect } from 'react';

import Lottie from 'lottie-react';
import { useParams } from 'react-router-dom';
import { useStripe } from '@stripe/react-stripe-js';

import loader from '../../../assets/loader.json';

export function HandleNextAction() {
  const { clientSecret } = useParams();
  const stripe = useStripe();

  const handleStripeAction = useCallback(
    async (clientSecret: string) => {
      if (stripe) {
        await stripe.handleNextAction({ clientSecret });
        window.close();
      }
    },
    [stripe]
  );

  useEffect(() => {
    if (clientSecret) {
      handleStripeAction(clientSecret);
    }
  }, [handleStripeAction, clientSecret]);

  return (
    <Lottie
      animationData={loader}
      style={{
        height: '160px',
      }}
      loop={true}
    />
  );
}
